// Browser-safe replacement for Node's `crypto.randomBytes(n).toString('hex')`.
// webpack 5 no longer polyfills node's `crypto`; the Web Crypto API is available in all
// evergreen browsers (the Vue-3 go-forward matrix). Produces the same 2-hex-chars-per-byte string.
export function randomHex (bytes) {
  const arr = new Uint8Array(bytes)
  ;(window.crypto || window.msCrypto).getRandomValues(arr)
  return Array.from(arr, b => b.toString(16).padStart(2, '0')).join('')
}
